export const jsonDecode = (json) => {
    let return_json = [];
    try {
        return_json = JSON.parse(json);
    } catch (e) {}

    return return_json;
};

export const jsonEncode = (json) => {
    let return_json = "";
    try {
        return_json = JSON.stringify(json);
    } catch (e) {}

    return return_json;
};
